import React, { useImperativeHandle, useRef, forwardRef } from "react";
import SignaturePad from "react-signature-canvas";
import { Button } from "./ui/button";
import { Eraser } from "lucide-react";
import { api } from "../lib/api";

const CANVAS_PROPS = {
  className: "w-full h-40 rounded-lg",
  willReadFrequently: true,
};

export const SignatureCapture = forwardRef(function SignatureCapture(
  { onSaved, testId = "signature-pad" },
  outerRef,
) {
  const ref = useRef();

  async function save() {
    if (!ref.current || ref.current.isEmpty()) return null;
    const dataUrl = ref.current.getTrimmedCanvas().toDataURL("image/png");
    const blob = await (await fetch(dataUrl)).blob();
    const file = new File([blob], "signature.png", { type: "image/png" });
    const fd = new FormData();
    fd.append("file", file);
    fd.append("folder", "signatures");
    const { data } = await api.post("/upload", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    onSaved?.(data.path);
    return data.path;
  }

  useImperativeHandle(outerRef, () => ({
    saveIfNotEmpty: save,
    isEmpty: () => !ref.current || ref.current.isEmpty(),
    clear: () => ref.current?.clear(),
  }));

  return (
    <div data-testid={testId}>
      <div className="border-2 border-dashed border-slate-300 rounded-lg bg-white">
        <SignaturePad
          ref={ref}
          canvasProps={CANVAS_PROPS}
        />
      </div>
      <div className="flex justify-between mt-2 gap-2">
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => ref.current?.clear()}
          data-testid={`${testId}-clear`}
        >
          <Eraser size={14} className="mr-1" /> Limpar
        </Button>
        <Button
          type="button"
          size="sm"
          onClick={save}
          data-testid={`${testId}-save`}
        >
          Salvar assinatura
        </Button>
      </div>
    </div>
  );
});
